import firebase from 'firebase'

export function fireInit(func) {
  
  var config = {
    apiKey: 'AIzaSyCuB8tfAPPhGTTen_YNAbSOLV_yk4lnTzE',
    authDomain: 'animated-carnival-81fe9.firebaseapp.com',
    databaseURL: 'https://animated-carnival-81fe9.firebaseio.com',
    storageBucket: 'animated-carnival-81fe9.appspot.com',
    messagingSenderId: '852641519152'
  }
  firebase.initializeApp(config)

  // firebase.auth().onAuthStateChanged(function (user) {
  //   if (user) {
  //     func(true, user)
  //   } else {
  //     func(false)
  //   }
  // }, function(error) {
  //   console.log(error)
  // })
}


// WEBPACK FOOTER //
// ./src/helpers/firebaseHelpers.js